"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_konva_1 = require("react-konva");
var TinyPieChart = function (_a) {
    var x = _a.x, y = _a.y, percentage = _a.percentage, radius = _a.radius, backgroundColor = _a.backgroundColor;
    var filledAngle = (percentage / 100) * 360;
    var startAngle = -90;
    var endAngle = startAngle + filledAngle;
    return (react_1["default"].createElement(react_konva_1.Group, { x: x, y: y },
        react_1["default"].createElement(react_konva_1.Circle, { x: radius, y: radius, radius: radius, fill: backgroundColor }),
        react_1["default"].createElement(react_konva_1.Circle, { x: radius, y: radius, radius: radius, fill: "rgba(0, 0, 0, 0.2)" }),
        react_1["default"].createElement(react_konva_1.Arc, { x: radius, y: radius, innerRadius: 0, outerRadius: radius, angle: filledAngle, rotation: startAngle, fill: "black" })));
};
exports["default"] = TinyPieChart;
